module.exports = __webpack_public_path__ + "media/images/bg-f6319ce0ed36cfd6210fea41b6aec3f9.jpg";